import { Component, OnInit, Input } from '@angular/core';
import { Site } from '../../shared/models/site';

@Component({
  selector: 'dw-site-health',
  templateUrl: './site-health.component.html',
  styleUrls: ['./site-health.component.scss']
})
export class SiteHealthComponent implements OnInit {
  @Input() public site: Site;

  constructor() { }

  ngOnInit() {
  }

}
